var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVermittlungVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 519.51 678.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: #29190f;\n      }\n\n      .cls-6 {\n        fill: #2c2334;\n      }\n\n      .cls-7 {\n        fill: #9289a1;\n      }\n\n      .cls-8 {\n        fill: #fff;\n      }\n\n      .cls-9 {\n        fill: #00bba6;\n      }\n\n      .cls-10 {\n        fill: #686173;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 354.13,
    y1: 670.56,
    x2: 354.13,
    y2: 250.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62cdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bba6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 218.56,
    y1: 102.56,
    x2: 218.56,
    y2: 288.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e4d6cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 270.03,
    x2: 218.56,
    y2: 538.2,
    gradientTransform: "translate(437.12 814.44) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 59.61,
    y1: 307.64,
    x2: 458.22,
    y2: 307.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91b7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c68b6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m485.27,243.93l-262.22-.04c-17.2,0-31.14,13.94-31.15,31.14l-.05,369.42c0,17.2,13.94,31.14,31.14,31.15l262.22.04c17.2,0,31.14-13.94,31.15-31.14l.05-369.42c0-17.2-13.94-31.14-31.14-31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m485.22,678.74h0v-3.1,3.1s-262.22-.04-262.22-.04c-9.15,0-17.74-3.56-24.21-10.03-6.47-6.47-10.03-15.07-10.02-24.21l.05-369.42c0-18.88,15.36-34.24,34.24-34.24l262.22.04c9.15,0,17.74,3.56,24.21,10.03,6.47,6.47,10.03,15.07,10.03,24.21l-.05,369.42c0,18.88-15.36,34.24-34.24,34.24ZM223.05,246.99c-15.46,0-28.04,12.58-28.04,28.04l-.05,369.42c0,7.49,2.91,14.53,8.21,19.83,5.3,5.3,12.34,8.21,19.83,8.22l262.22.04v3.1s0-3.1,0-3.1c15.46,0,28.04-12.58,28.04-28.04l.05-369.42c0-7.49-2.91-14.53-8.21-19.83-5.3-5.3-12.34-8.21-19.83-8.22l-262.22-.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m262.84,286.11h-30.82c-1.64,0-2.98-1.33-2.98-2.98h0c0-1.64,1.33-2.98,2.98-2.98h30.82c1.64,0,2.98,1.33,2.98,2.98h0c0,1.64-1.33,2.98-2.98,2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m309.6,286.11h-30.82c-1.64,0-2.98-1.33-2.98-2.98h0c0-1.64,1.33-2.98,2.98-2.98h30.82c1.64,0,2.98,1.33,2.98,2.98h0c0,1.64-1.33,2.98-2.98,2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m477.37,286.11h-30.82c-1.64,0-2.98-1.33-2.98-2.98h0c0-1.64,1.33-2.98,2.98-2.98h30.82c1.64,0,2.98,1.33,2.98,2.98h0c0,1.64-1.33,2.98-2.98,2.98Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 242.05,
    y: 324.97,
    width: 52.24,
    height: 52.24,
    rx: 12.43,
    ry: 12.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m463.14,334.65h-110.13c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h110.13c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m463.14,355.93h-128.47c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h128.47c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m441.08,377.21h-106.41c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h106.41c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.9 341.58 265.15 362.86 290.36 319.94 261.15 349.74 242.9 341.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 242.05,
    y: 405.94,
    width: 52.24,
    height: 52.24,
    rx: 12.43,
    ry: 12.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m463.14,415.62h-110.13c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h110.13c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m463.14,436.9h-128.47c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h128.47c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m441.08,458.18h-106.41c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h106.41c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.87 425.48 262.12 446.77 290.36 400.91 261.15 430.71 239.87 425.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 242.05,
    y: 486.91,
    width: 52.24,
    height: 52.24,
    rx: 12.43,
    ry: 12.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 348.17,
    y: 486.91,
    width: 119.8,
    height: 9.67,
    rx: 4.84,
    ry: 4.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m463.14,517.87h-128.47c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h128.47c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m441.08,539.15h-106.41c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h106.41c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.87 506.45 262.12 527.74 290.36 481.88 261.15 511.68 239.87 506.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 242.05,
    y: 567.88,
    width: 52.24,
    height: 52.24,
    rx: 12.43,
    ry: 12.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m463.14,577.56h-110.13c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h110.13c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m463.14,598.84h-128.47c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h128.47c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m441.08,620.12h-106.41c-2.67,0-4.84-2.17-4.84-4.84h0c0-2.67,2.17-4.84,4.84-4.84h106.41c2.67,0,4.84,2.17,4.84,4.84h0c0,2.67-2.17,4.84-4.84,4.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m406.66,0H30.46C13.64,0,0,13.55,0,30.27v485.21c0,16.72,13.64,30.27,30.46,30.27h376.19c16.82,0,30.46-13.55,30.46-30.27V30.27c0-16.72-13.64-30.27-30.46-30.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.27,4.16h332.59c26.24,0,47.54,21.3,47.54,47.54v221.17H4.73V51.7C4.73,25.46,26.03,4.16,52.27,4.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 153.16,
    y: 166.11,
    width: 135.06,
    height: 87.5,
    rx: 22.46,
    ry: 22.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m52.27,272.87h332.59c26.24,0,47.54,21.3,47.54,47.54v221.17H4.73v-221.17c0-26.24,21.3-47.54,47.54-47.54Z",
    transform: "translate(437.12 814.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.44,
    y: 292.74,
    width: 390.29,
    height: 29.8,
    rx: 14.9,
    ry: 14.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m78.18,310.83h-35.24c-1.76,0-3.19-1.43-3.19-3.19h0c0-1.76,1.43-3.19,3.19-3.19h35.24c1.76,0,3.19,1.43,3.19,3.19h0c0,1.76-1.43,3.19-3.19,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m310.22,310.83h-35.24c-1.76,0-3.19-1.43-3.19-3.19h0c0-1.76,1.43-3.19,3.19-3.19h35.24c1.76,0,3.19,1.43,3.19,3.19h0c0,1.76-1.43,3.19-3.19,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m397.32,310.83h-73.98c-1.76,0-3.19-1.43-3.19-3.19h0c0-1.76,1.43-3.19,3.19-3.19h73.98c1.76,0,3.19,1.43,3.19,3.19h0c0,1.76-1.43,3.19-3.19,3.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 37.95,
    y: 347.33,
    width: 105.02,
    height: 105.02,
    rx: 20.69,
    ry: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 172.67,
    y: 345.25,
    width: 87.16,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 172.67,
    y: 364.23,
    width: 51.68,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 172.67,
    y: 383.21,
    width: 87.16,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 344.4,
    y: 345.25,
    width: 53.1,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 344.4,
    y: 364.23,
    width: 31.49,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 344.4,
    y: 383.21,
    width: 53.1,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 172.67,
    y: 406.45,
    width: 71.91,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 286.86,
    y: 57.94,
    width: 87.16,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 286.86,
    y: 76.93,
    width: 51.68,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 286.86,
    y: 95.91,
    width: 87.16,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 286.86,
    y: 119.15,
    width: 71.91,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 172.67,
    y: 429.69,
    width: 41.81,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.87,
    y: 429.69,
    width: 75.93,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 322.64,
    y: 429.69,
    width: 43.64,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 377.63,
    y: 429.69,
    width: 22,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m197.27,462.1h-22.23c-1.31,0-2.37-1.06-2.37-2.37h0c0-1.31,1.06-2.37,2.37-2.37h22.23c1.31,0,2.37,1.06,2.37,2.37h0c0,1.31-1.06,2.37-2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m257.47,462.1h-22.23c-1.31,0-2.37-1.06-2.37-2.37h0c0-1.31,1.06-2.37,2.37-2.37h22.23c1.31,0,2.37,1.06,2.37,2.37h0c0,1.31-1.06,2.37-2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m324.53,462.1h-22.23c-1.31,0-2.37-1.06-2.37-2.37h0c0-1.31,1.06-2.37,2.37-2.37h22.23c1.31,0,2.37,1.06,2.37,2.37h0c0,1.31-1.06,2.37-2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m391.59,462.1h-22.23c-1.31,0-2.37-1.06-2.37-2.37h0c0-1.31,1.06-2.37,2.37-2.37h22.23c1.31,0,2.37,1.06,2.37,2.37h0c0,1.31-1.06,2.37-2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 41.45,
    y: 485.4,
    width: 358.47,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 41.45,
    y: 502.43,
    width: 358.47,
    height: 4.97,
    rx: 2.48,
    ry: 2.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m88.98,106.81l14.19-47.09h14.36l-21.8,62.61h-13.46l-21.72-62.61h14.32l14.11,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.14,122.34h-12.9v-62.61h12.9v62.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m181.56,105.91c0-1.09-.16-2.07-.47-2.95-.32-.87-.93-1.68-1.83-2.43-.9-.74-2.15-1.48-3.74-2.19-1.59-.72-3.65-1.48-6.17-2.28-2.87-.92-5.57-1.95-8.11-3.1-2.54-1.15-4.76-2.5-6.67-4.06-1.91-1.56-3.41-3.36-4.52-5.4-1.1-2.03-1.66-4.41-1.66-7.14s.57-5,1.7-7.16c1.13-2.16,2.72-4.01,4.77-5.53,2.05-1.52,4.49-2.7,7.31-3.55s5.93-1.27,9.31-1.27,6.62.48,9.46,1.44c2.84.96,5.26,2.3,7.27,4.02,2.01,1.72,3.56,3.76,4.64,6.13,1.09,2.37,1.63,4.95,1.63,7.76h-12.9c0-1.32-.21-2.54-.62-3.66-.42-1.12-1.05-2.08-1.91-2.88-.86-.8-1.94-1.43-3.23-1.87-1.29-.44-2.81-.67-4.56-.67s-3.16.19-4.41.56c-1.25.37-2.28.89-3.1,1.55-.82.66-1.43,1.43-1.85,2.32-.42.89-.62,1.84-.62,2.84,0,2.06,1.05,3.79,3.16,5.18,2.11,1.39,5.2,2.69,9.27,3.89,3.41,1.06,6.42,2.24,9.01,3.53,2.59,1.29,4.76,2.75,6.49,4.38,1.73,1.63,3.05,3.47,3.93,5.5.89,2.04,1.33,4.34,1.33,6.92,0,2.75-.54,5.2-1.61,7.35-1.08,2.15-2.6,3.96-4.58,5.44-1.98,1.48-4.36,2.61-7.16,3.4-2.79.79-5.91,1.18-9.35,1.18-2.06,0-4.13-.18-6.19-.54-2.06-.36-4.04-.91-5.91-1.66-1.88-.74-3.62-1.68-5.22-2.79-1.61-1.12-3-2.44-4.19-3.96-1.19-1.52-2.12-3.25-2.8-5.18-.67-1.93-1.01-4.08-1.01-6.43h12.94c0,1.89.3,3.5.9,4.82.6,1.32,1.44,2.39,2.52,3.2,1.08.82,2.37,1.41,3.89,1.78,1.52.37,3.21.56,5.07.56,1.66,0,3.11-.18,4.34-.54,1.23-.36,2.25-.85,3.05-1.48.8-.63,1.4-1.38,1.79-2.26.39-.87.58-1.81.58-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m238.58,109.43h-22.62l-4.3,12.9h-13.72l23.31-62.61h11.95l23.44,62.61h-13.72l-4.34-12.9Zm-19.14-10.45h15.65l-7.87-23.44-7.78,23.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m322.81,254.69c-32.03,0-58.09-26.06-58.09-58.09s26.06-58.09,58.09-58.09,58.09,26.06,58.09,58.09-26.06,58.09-58.09,58.09Zm0-108.04c-27.55,0-49.95,22.41-49.95,49.95s22.41,49.95,49.95,49.95,49.95-22.41,49.95-49.95-22.41-49.95-49.95-49.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m308.71,218.27l-12.75-12.75c-3.81-3.81-3.81-9.97,0-13.78h0c3.81-3.81,9.98-3.81,13.78,0l6.69,6.69,16.1-17.2c3.68-3.93,9.84-4.13,13.77-.46h0c3.93,3.68,4.13,9.84.46,13.77l-21.95,23.46c-4.33,4.62-11.62,4.74-16.1.27Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVermittlungVisa);
export default __webpack_public_path__ + "static/media/vermittlung-visa.e17c59b8ce087ecef99a85b4fc2a6e9b.svg";
export { ForwardRef as ReactComponent };